"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("es6-promise");
var calendar_state_1 = require("./classes/calendar-state");
var calendar_api_1 = require("./apis/calendar-api");
var calendar_reducer_1 = require("./reducer/calendar-reducer");
var action_struct_1 = require("./actions/action-struct");
var Actions = require("./actions/actions");
var moment = require("moment");
var _ = require("lodash");
var Rx = require("rx");
var redux = require("redux");
var _calendarState;
var _events;
var _eventsByMonth;
var _loadEvents;
var _calendarSettings;
var _defaultCalendarModel;
var initialStartDate;
var initialEndDate;
function createCombinedStore(additionalReducers, initialState, calendarSettings) {
    if (calendarSettings === void 0) { calendarSettings = { loadWrappingMonthDates: false, saveHistory: false }; }
    _calendarSettings = calendarSettings;
    _defaultCalendarModel = initialState && initialState.calendarModel ? initialState.calendarModel : calendar_state_1.defaultCalendarModel;
    _events = new Rx.Subject();
    _loadEvents = new Rx.Subject();
    var combinedReducers = redux.combineReducers(_.assign(additionalReducers, { "calendarModel": calendar_reducer_1.reduce }));
    _calendarState = redux.createStore(combinedReducers, initialState);
    _loadEvents.flatMapLatest(function (state) {
        return eventsCache(state).then(function (events) {
            return events;
        });
    }).subscribe(function (events) {
        _calendarState.dispatch({ type: action_struct_1.ActionType.EventUpdated });
        var filteredEvents = _.filter(events, _calendarState.getState().calendarModel.filterFunction);
        var byMonth = _.groupBy(filteredEvents, function (event) {
            var momentObj = moment(event.eventDate);
            return momentObj.year().toString() + "," + momentObj.month().toString();
        });
        var allMonths = [];
        for (var i = _calendarState.getState().calendarModel.startDate.clone(); i.isBefore(_calendarState.getState().calendarModel.endDate); i.add(1, "month")) {
            allMonths.push(i.clone());
        }
        var monthsToEvents = allMonths.map(function (monthMoment) {
            var evts = byMonth[monthMoment.year().toString() + "," + monthMoment.month().toString()];
            if (!evts)
                evts = [];
            return {
                monthMoment: monthMoment,
                events: evts
            };
        });
        _calendarState.dispatch({
            type: action_struct_1.ActionType.UpdateEvents,
            value: monthsToEvents ? monthsToEvents : []
        });
        _events.onNext(events);
    });
    _calendarState.subscribe(function () {
        if (_calendarState.getState().calendarModel.updating)
            _loadEvents.onNext(_calendarState.getState().calendarModel);
    });
    CalendarActions.setDates(_defaultCalendarModel.startDate, _defaultCalendarModel.endDate);
}
exports.createCombinedStore = createCombinedStore;
function createCalendarStore(calendarModel, calendarSettings) {
    if (calendarModel === void 0) { calendarModel = calendar_state_1.defaultCalendarModel; }
    if (calendarSettings === void 0) { calendarSettings = { loadWrappingMonthDates: false, saveHistory: false }; }
    _calendarSettings = calendarSettings;
    _defaultCalendarModel = calendarModel;
    _events = new Rx.Subject();
    _loadEvents = new Rx.Subject();
    var initialState = calendar_state_1.defaultCalendarModel;
    initialStartDate = moment(calendar_state_1.defaultCalendarModel.startDate).format('YYYY-MM-DD');
    initialEndDate = moment(calendar_state_1.defaultCalendarModel.endDate).format('YYYY-MM-DD');
    if (window.location.hash) {
        var state = window.location.hash;
        if (Object.keys(state).some(_.identity)) {
            initialState = deserializeProps(state);
        }
    }
    _calendarState = redux.createStore(calendar_reducer_1.reduce, initialState);
    _loadEvents.flatMapLatest(function (state) {
        return eventsCache(_calendarState.getState()).then(function (events) {
            return events;
        });
    }).subscribe(function (events) {
        _calendarState.dispatch({ type: action_struct_1.ActionType.EventUpdated });
        var filteredEvents = _.filter(events, _calendarState.getState().filterFunction);
        var byMonth = _.groupBy(filteredEvents, function (event) {
            var momentObj = moment(event.eventDate);
            return momentObj.year().toString() + "," + momentObj.month().toString();
        });
        var allMonths = [];
        for (var i = _calendarState.getState().startDate.clone(); i.isBefore(_calendarState.getState().endDate); i.add(1, "month")) {
            allMonths.push(i.clone());
        }
        var monthsToEvents = allMonths.map(function (monthMoment) {
            var evts = byMonth[monthMoment.year().toString() + "," + monthMoment.month().toString()];
            if (!evts)
                evts = [];
            return {
                monthMoment: monthMoment,
                events: evts
            };
        });
        _calendarState.dispatch({
            type: action_struct_1.ActionType.UpdateEvents,
            value: monthsToEvents ? monthsToEvents : []
        });
        _events.onNext(events);
    });
    _calendarState.subscribe(function () {
        if (_calendarState.getState().updating)
            _loadEvents.onNext(_calendarState.getState());
    });
    CalendarActions.setDates(_defaultCalendarModel.startDate, _defaultCalendarModel.endDate);
    if (window.location.hash.length > 1) {
        navigate(window.location.hash, true);
        if (_calendarSettings.saveHistory) {
            _calendarState
                .subscribe(function () {
                var currState = _calendarState.getState();
                if (currState.updating) {
                    var serialized = serializeProps(currState);
                    window.location.hash = serialized;
                }
            });
        }
    }
}
exports.createCalendarStore = createCalendarStore;
var CalendarActions = (function () {
    function CalendarActions() {
    }
    CalendarActions.calendarDispatch = function () {
        return _calendarState.dispatch;
    };
    CalendarActions.calendarState = function () {
        return _calendarState.getState();
    };
    CalendarActions.calendarStore = function () {
        return _calendarState;
    };
    CalendarActions.nextMonth = function () {
        _calendarState.dispatch(Actions.nextMonth());
    };
    CalendarActions.previousMonth = function () {
        _calendarState.dispatch(Actions.previousMonth());
    };
    CalendarActions.addDays = function (numberOfDays, extendDays) {
        if (extendDays === void 0) { extendDays = false; }
        _calendarState.dispatch(Actions.addDays(numberOfDays, extendDays));
    };
    CalendarActions.setMonth = function (month) {
        _calendarState.dispatch(Actions.setMonth(month));
    };
    CalendarActions.goToMonth = function (month) {
        _calendarState.dispatch(Actions.goToMonth(month));
    };
    CalendarActions.setDates = function (startDate, endDate) {
        _calendarState.dispatch(Actions.setDates(startDate, endDate));
    };
    CalendarActions.updateEventFilter = function (filterFunction) {
        _calendarState.dispatch(Actions.updateEventFilter(filterFunction));
    };
    CalendarActions.changeProductionSeasonFilter = function (filter) {
        _calendarState.dispatch(Actions.changeProductionSeasonFilter(filter));
    };
    CalendarActions.getEventsByMonth = function () {
        return _eventsByMonth;
    };
    CalendarActions.onEventsChange = function (success, failure, complete) {
        _events.subscribe(success, failure, complete);
    };
    return CalendarActions;
}());
exports.CalendarActions = CalendarActions;
function navigate(urlState, shouldUpdate) {
    var state = deserializeProps(urlState);
    if (!shouldUpdate)
        return;
    _calendarState.dispatch({
        type: action_struct_1.ActionType.BrowserNavigated,
        value: { state: state, shouldUpdate: shouldUpdate }
    });
}
var eventsCache = _.memoize(updateEvents, function (state) { return state.startDate.format('YYYY-MM-DD') + '~'
    + state.endDate.format('YYYY-MM-DD') + '~' + +state.productionSeasonFilter.toString(); });
function updateEvents(state) {
    if (state.productionSeasonFilter > 0) {
        if (_calendarSettings.loadWrappingMonthDates) {
            return calendar_api_1.default.getProductionEventsForDates("", state.productionSeasonFilter, moment(state.startDate).startOf('week').format('YYYY-MM-DD'), moment(state.endDate).endOf('week').format('YYYY-MM-DD')).then(function (events) {
                state.updating = false;
                return events;
            });
        }
        else {
            return calendar_api_1.default.getProductionEventsForDates("", state.productionSeasonFilter, state.startDate.format('YYYY-MM-DD'), state.endDate.format('YYYY-MM-DD')).then(function (events) {
                state.updating = false;
                return events;
            });
        }
    }
    else {
        if (_calendarSettings.loadWrappingMonthDates && !state.specificDates) {
            return calendar_api_1.default.getEventsForDates("", moment(state.startDate).startOf('week').format('YYYY-MM-DD'), moment(state.endDate).endOf('week').format('YYYY-MM-DD')).then(function (events) {
                state.updating = false;
                return events;
            });
        }
        else {
            return calendar_api_1.default.getEventsForDates("", state.startDate.format('YYYY-MM-DD'), state.endDate.format('YYYY-MM-DD')).then(function (events) {
                state.updating = false;
                return events;
            });
        }
    }
}
function serializeProps(state) {
    var urlState = Object.keys(_defaultCalendarModel)
        .filter(function (key) { return key !== 'events' && key !== 'eventFilter' && key !== 'updating'; })
        .reduce(function (acc, key) {
        var value = JSON.stringify(state[key]);
        if (key == "startDate" || key == "endDate") {
            value = moment(state[key]).format('YYYY-MM-DD');
        }
        var defaultValue = JSON.stringify(_defaultCalendarModel[key]);
        if (value === defaultValue) {
            return acc;
        }
        acc[key] = value;
        return acc;
    }, {});
    return JSON.stringify(urlState);
}
function deserializeProps(urlState) {
    return Object.keys(_defaultCalendarModel).reduce(function (acc, key) {
        var urlValue = urlState[key];
        if (key === "startDate") {
            acc[key] = typeof urlValue === 'undefined' ? moment(initialStartDate) : moment(urlValue);
        }
        else if (key === "endDate") {
            if (typeof urlValue === 'undefined') {
                acc[key] = moment(initialEndDate);
                if (!moment(acc["startDate"]).isSame(moment(initialStartDate)))
                    acc[key] = typeof _defaultCalendarModel[key] === 'undefined' ? moment(acc["startDate"]).endOf('month')
                        : _defaultCalendarModel[key];
            }
            else {
                acc[key] = moment(urlValue);
            }
        }
        else
            acc[key] = typeof urlValue === 'undefined' ? _defaultCalendarModel[key] : JSON.parse(urlValue);
        return acc;
    }, {});
}
exports.name = 'AceCalendarContainer';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@adage/ace-calendar/app/index.js
// module id = 272
// module chunks = 0